import React from 'react';
import { Link } from 'react-router-dom';
import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from '@mui/material';

function SidebarNavItem({
    icon: Icon,
    label,
    to,
    onClick,
    selected = false,
    collapsed = false,
}) {
    return (
        <ListItem
            button
            component={to ? Link : 'div'}
            to={to}
            onClick={onClick}
            selected={selected}
            sx={{
                py: 0.75,
                px: collapsed ? 1.5 : 2,
                justifyContent: collapsed ? 'center' : 'flex-start',
                minHeight: 44,
            }}
        >
            <Tooltip title={label} placement="right" disableHoverListener={!collapsed}>
                <ListItemIcon
                    sx={{
                        minWidth: collapsed ? 0 : 32,
                        justifyContent: 'center',
                        color: 'inherit',
                    }}
                >
                    <Icon fontSize="small" />
                </ListItemIcon>
            </Tooltip>
            {!collapsed && (
                <ListItemText
                    primary={label}
                    primaryTypographyProps={{ variant: 'body2', noWrap: true }}
                />
            )}
        </ListItem>
    );
}

export default SidebarNavItem;
